import $ from "jquery";

const faq = (scroll) => {
    $(".faq__item__header").on('click', function () {
      let $this = $(this);
      $this.next(".faq__item__body").slideToggle();
      $this.parent(".faq__item").toggleClass("active");
      scroll.update();
    });

    $(".faq .more").on('click', function () {
      let $faqItem = $(this).closest(".faq").find(".faq__item");
      let $icon = $(this).children('.icon-plus');
  
      if (!$faqItem.hasClass('active')) {
          $faqItem.find('.faq__item__body').slideDown(function() {
              scroll.update();
          });
          $faqItem.addClass('active');
          
          $icon.css({ transform: 'rotate(135deg)' });
          $(this).children('.change-text').text('Close all'); 
      } else {
          $faqItem.find('.faq__item__body').slideUp(function(){
              scroll.update();
          });
          $faqItem.removeClass('active');
          
          $icon.css({ transform: 'rotate(0deg)' });
          $(this).children('.change-text').text('Open all'); 
      }
    });
};

export default faq;
